import React from 'react';
import PropTypes from 'prop-types';

import {
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Close as CloseIcon,
  FiberManualRecord as ObjectIcon,
  OpenInNew as ExtLinkIcon,
} from '@material-ui/icons';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { BucketIcon } from '../../aws';

import { 
  fmtBytes,
  fmtS3ConsoleLink,
} from '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '8px',
    whiteSpace: 'normal',
    height: 'auto',
  },
  label: {
    // display: 'flex',
    // flexGrow: 2,
    paddingTop: '4px',
    paddingBottom: '4px',
    width: 'calc(100% - 58px)',
    whiteSpace: 'normal',
  },
  info: {
    display: 'flex',
    flexFlow: 'column',
    //overflow: 'hidden',
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  description: {
  },
  typography: {
  }
}));

export default function ExecutionInputChip(props) {
  const { value, maxWidth } = props;
  const classes = useStyles();

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [actionMessage, setActionMessage] = React.useState("");
  const executionInput=value;
  const inputName=executionInput?executionInput.InputUri.split('/').slice(-1)[0]:null;
  const inputSize=executionInput?fmtBytes(executionInput.InputSizeInBytes):null;
  const href = fmtS3ConsoleLink(executionInput.InputUri);

  const handleExtLink = () => {
    window.open(href,"_blank");
    handleCloseMenu();
  };

  const handleClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleActionPerformed = (message) => {
    setActionMessage(message);
    handleCloseMenu();
  };

  const clearActionMessage = () => {
    setActionMessage("");
  };


  return (
    <React.Fragment>
      <Chip
        classes={{ root: classes.root, label: classes.label }}
        variant="outlined"
        icon=<ObjectIcon/>
        label={
          <div className={classes.info}>
            <div className={classes.name}>
              <Typography className={classes.typography} variant='inherit' color='primary'>
                {inputName}
              </Typography>
            </div>
            <div className={classes.description}>
              <Typography className={classes.typography} variant='inherit' >
                {inputSize}
              </Typography>
              {executionInput.InputSha256?
                <Chip label="SHA256" 
                  style={{ marginLeft: '8px', height: '16px', borderRadius: '6px', fontSize: '0.7rem' }}/>:null
              }
            </div>
          </div>
        }
        onClick={handleClick}
        onDelete={handleExtLink}
        deleteIcon={<BucketIcon titleAccess="View in S3..."/>}
        style={{ maxWidth }}
      />
      <Menu
        id="action-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
      >
        <CopyToClipboard 
            text={executionInput.InputUri} 
            onCopy={() => handleActionPerformed('S3 URI copied to clipboard')}>
          <MenuItem>Copy S3 URI...</MenuItem>
        </CopyToClipboard>
        <CopyToClipboard 
            text={executionInput.InputSha256} 
            onCopy={() => handleActionPerformed('SHA256 copied to clipboard')}>
          <MenuItem>Copy SHA256 Content Digest...</MenuItem>
        </CopyToClipboard>
        <CopyToClipboard 
            text={href} 
            onCopy={() => handleActionPerformed('S3 Console URL copied to clipboard')}>
          <MenuItem>Copy S3 Console URL...</MenuItem>
        </CopyToClipboard>
        <MenuItem onClick={handleExtLink}>View object in S3 Console&nbsp;<ExtLinkIcon fontSize="small"/></MenuItem>
      </Menu>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={actionMessage.length>0}
        autoHideDuration={3000}
        onClose={clearActionMessage}
        message={actionMessage}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={clearActionMessage}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </React.Fragment>
  );
}

ExecutionInputChip.propTypes = {
  value: PropTypes.object.isRequired,
  maxWidth: PropTypes.string,
};

ExecutionInputChip.defaultProps = {
};

